<template>
  <section class="container mt-10 overflow-hidden">
    <div class="flex max-w-6xl justify-between">
      <ProductCardSkeleton class="max-w-xl" />
      <div class="space-y-3">
        <SkeletonLoader type="headline" full-width />
        <div class="w-12">
          <SkeletonLoader type="headline" />
        </div>
        <SkeletonLoader type="headline" full-width />
        <SkeletonLoader type="headline" full-width />
        <SkeletonLoader class="mt-20" type="button" />
      </div>
    </div>
  </section>
</template>
